import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { ProjectProps } from '../../../types/IdProps';
import AddBusinessPartnerPopup from '../Popups/Project_popup_AddBusinessPartner';

const Project_tab_BusinessPartners: React.FC<ProjectProps> = ({ projectId, projectTypeId, refreshDataCounter }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForProjectType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [projectId, refreshDataCounter]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ProjectBusinessPartners/ByProject/' + projectId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProjectBusinessPartners/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerId', visible: false },
        { title: 'Name', dataProp: 'businessPartner.name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Type', dataProp: 'businessPartner.businessPartnerType.name', sort: 'asc', filterInfo: { filterType: 'CheckboxList' } },
    ];
    if (isAuthorizedForProjectType(ApplicationFunctions.UpdateProject, projectTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtProjectBusinessPartners'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Businesspartner'
                navigateUrl='/plm/BusinessPartners/Details/'
            />
            <AddBusinessPartnerPopup projectId={projectId} projectTypeId={projectTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />
        </>
    );
}
export default Project_tab_BusinessPartners;